import httper from '../../common/httper.js'
import Qs from 'Qs'
const http = httper.create('/api/pc')

export default {
  login: (data) => http.post('/sample/account/login', Qs.stringify(data)),
}



// WEBPACK FOOTER //
// ./src/services/login/api.js